import { StreamableFile } from "@nestjs/common";
import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { sendMessageBodySchema } from "../schemas/domains/agentChat/agent-chat-events.schema";
import {
    agentChatTurnResponseSchema,
    conversationListResponseSchema,
    conversationWithMessagesResponseSchema,
} from "../schemas/domains/agentChat/agent-chat.schema";

const c = initContract();

export const agentChatContract = c.router({
    sendMessage: {
        method: "POST",
        path: "/agent-chat/messages",
        body: sendMessageBodySchema,
        responses: {
            200: agentChatTurnResponseSchema,
            400: ErrorMessageSchema,
            404: ErrorMessageSchema,
            422: ErrorMessageSchema,
        },
    },
    listConversations: {
        method: "GET",
        path: "/agent-chat/conversations",
        query: z.object({
            workspaceId: z.string().uuid(),
            limit: z.coerce.number().int().min(1).max(50).default(20),
            offset: z.coerce.number().int().min(0).default(0),
        }),
        responses: {
            200: conversationListResponseSchema,
            400: ErrorMessageSchema,
            404: ErrorMessageSchema,
        },
    },
    getConversation: {
        method: "GET",
        path: "/agent-chat/conversations/:conversationId",
        pathParams: z.object({ conversationId: z.string().uuid() }),
        query: z.object({
            workspaceId: z.string().uuid(),
            messageLimit: z.coerce.number().int().min(1).max(100).default(100),
            messageOffset: z.coerce.number().int().min(0).default(0),
        }),
        responses: {
            200: conversationWithMessagesResponseSchema,
            404: ErrorMessageSchema,
        },
    },
    getAttachmentImage: {
        method: "GET",
        path: "/agent-chat/attachment-image/:financialDocumentId",
        pathParams: z.object({
            financialDocumentId: z.coerce.number().int().positive(),
        }),
        query: z.object({
            token: z.string().optional(),
        }),
        responses: {
            200: c.type<StreamableFile>(),
            401: ErrorMessageSchema,
            404: ErrorMessageSchema,
            410: ErrorMessageSchema,
        },
    },
});
